import React, { Component, createRef } from "react";
import $ from 'jquery';
import { fabric } from 'fabric';
import {
  PdfLoader,
  PdfHighlighter,
  Tip,
  Highlight,
  Popup,
  AreaHighlight,
} from "./react-pdf-highlighter";

import type { IHighlight, NewHighlight } from "./react-pdf-highlighter";
import { Link, useHistory, useLocation, Redirect, withRouter } from "react-router-dom";
import { testHighlights as _testHighlights } from "./test-highlights";
import { Spinner } from "./Spinner";
import { Sidebar } from "./Sidebar";
import { Layout, Menu, Card, Row, Col, List, Divider, Table, Spin, Button, Space, message, Input, Select, Upload, Tabs, Image } from 'antd';
import Container from '../Layout/Container';
import {
  LeftOutlined,
  RightOutlined,
  LoadingOutlined,
  ArrowLeftOutlined,
  SyncOutlined,
  CloseOutlined,
  EditOutlined
} from "@ant-design/icons";
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import {
  DownloadOutlined,
  PrinterOutlined,
  MenuFoldOutlined,
} from '@ant-design/icons';
import "./style/App.css";
import { FaSignature } from 'react-icons/fa';
import { connect } from 'react-redux';
import { getDocumentHighlights, AddHighlightsAsyn, DocumentEditorSelector, getIncryptedPDF, EncrptyPdfDataDelAsyn, clearAddResponseState as ClearAddHighlightState, getDocumentDetailAsyn, getDocumentDetailV2Asyn, unsetDocumentDetailStateAsync, pdfNewProcessAsyn, AddHistoryAsyn, getEditHistoryDataAsyn, EditHistoryRecordAsyn, DeleteEditHistoryRecordAsyn } from './DocumentEditorSlice';
import { getDocumentComments } from '../DocumentComments/DocumentCommentsSlice';
import history from "../../history";
import { createBrowserHistory } from "history";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { dispatch } from "react-hot-toast/dist/core/store";
import ImageResize from 'quill-image-resize-module-react';
import BlotFormatter, { AlignAction, DeleteAction, ImageSpec } from "quill-blot-formatter";
const { Header, Content, Footer, Sider } = Layout;
const testHighlights: Record<string, Array<IHighlight>> = _testHighlights;
const { TabPane } = Tabs;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;

Quill.register('modules/imageResize', ImageResize);
Quill.register('modules/blotFormatter', BlotFormatter);
var Font = Quill.import('formats/font');
Font.whitelist = ["arial", "tnr", "monospace", "cursive", "fantasy", "sans-serif", "serif", "FreeMono"];
Quill.register(Font, true);

const modules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"],
    [{ font: Font.whitelist }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link", "image", "video"],
    ["code-block"],
    [{ direction: "rtl" }],
    ["formula"],
    [{ size: ["small", false, "large", "huge"] }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ script: "sub" }, { script: "super" }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }], //dropdown with defaults from theme
    // [{ font: [] }],
    ["clean"],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false
  },
  imageResize: {
    parchment: Quill.import('parchment'),
    modules: ['Resize', 'DisplaySize', 'Toolbar']
  },
};

const recived = [
  {
    title: 'Recived item 1',
  }
];

interface State {
  url: string;
  highlights: Array<IHighlight>;
  esignImage: string;
  isShowpdfColumn: boolean;
  seenStamp: boolean;
  pdfDOc: any;
  isLoading: boolean;
  pdfInfo: any;
  tittleData: any;
  editHistroyData: Array<IHighlight>;
  displayAddbtn: boolean;
  displayUpdatebtn: boolean;
  displayDelbtn: boolean;
  editDelId: string;
  // AddHighlightsAsyn: any;
  // clearAddResponseState: any;
}


let fabricjs: any = fabric;


const getNextId = () => String(Math.random()).slice(2);

const parseIdFromHash = () =>
  document.location.hash.slice("#highlight-".length);

const resetHash = () => {
  document.location.hash = "";
};

const HighlightPopup = ({
  comment,
}: {
  comment: { text: string; emoji: string };
}) =>
  comment.text ? (
    <div className="Highlight__popup">
      {comment.emoji} {comment.text}
    </div>
  ) : null;


const { documentInfo }: any = history.location.state ? history.location.state : '';


let number_of_pages = 0;
let pages_rendered = 0;
let active_tool = 1; // 1 - Free hand, 2 - Text, 3 - Arrow, 4 - Rectangle
let fabricObjects: any[] = [];
let fabricObjectsData: any[] = [];
let color = '#212121';
let borderColor = '#000000';
let borderSize = 1;
let font_size = 16;
let active_canvas = 0;
let container_id = 'pdfViewer';
let options = {};



export interface IProps {
  getDocumentDetailAsyn: Function,
  getDocumentDetailV2Asyn: Function,
  documentDetailData: any,
  history: any,
  location: any,
  getDocumentHighlights: Function,
  documentData: any[],
  AddHighlightsAsyn: Function,
  getIncryptedPDF: Function,
  EncrptyPdfDataDelAsyn: Function,
  ClearAddHighlightState: Function,
  unsetDocumentDetailStateAsync: Function,
  pdfNewProcessAsyn: Function,
  AddHistoryAsyn: Function,
  getEditHistoryDataAsyn: Function,
  EditHistoryRecordAsyn: Function,
  DeleteEditHistoryRecordAsyn: Function,
}

// class DocumentVerification extends Component<{history:any}, State> {
class DocumentEditor extends Component<IProps, State> {
  viewer: PdfLoader | null | undefined;
  pdfhighlightRef: any;
  pdfjslibRef: any;
  sigPad: any;
  mainRef: any;


  constructor(props: any) {
    super(props);
    this.state = {
      url: '',
      // highlights: testHighlights[initialUrl]
      //   ? [...testHighlights[initialUrl]]
      //   : [],
      highlights: [],
      esignImage: '',
      isShowpdfColumn: true,
      seenStamp: props.location.state ? props.location.state.documentInfo.documentUpdatedData.seenStamp : false,
      // seenStamp:history.location.state?documentInfo.documentUpdatedData.seenStamp:false,
      pdfDOc: null,
      isLoading: false,
      pdfInfo: null,
      tittleData: '',
      editHistroyData: [],
      displayAddbtn: true,
      displayUpdatebtn: false,
      displayDelbtn: false,
      editDelId: '',
    };
    this.printDocumentAsPdf = this.printDocumentAsPdf.bind(this);
    this.hidePdfDiv = this.hidePdfDiv.bind(this);
    this.showPdfDiv = this.showPdfDiv.bind(this);
    this.setPdfFile = this.setPdfFile.bind(this);
    this.togglePdfDiv = this.togglePdfDiv.bind(this);
    this.closePdfDiv = this.closePdfDiv.bind(this);
    // this.downloadClicked = this.downloadClicked.bind(this)
    this.initiatpdfNewProcess = this.initiatpdfNewProcess.bind(this);
    this.pdfhighlightRef = React.createRef()
    this.pdfjslibRef = React.createRef();
    this.sigPad = React.createRef();
    this.mainRef = createRef();
    //  this.pdfjslibRef = React.forwardRef();
  }

  componentDidMount() {
    localStorage.setItem('PRIMARYPDFURL', '');
    const { location }: any = this.props;
    // console.log('location.state.processId', this.props.location.state.processId)

    this.props.getEditHistoryDataAsyn(location.state.processId).then((res: any) => {
      // console.log('getEditHistoryDataAsyn', res)
      if (res.message === "Fetched") {
        this.setState({
          editHistroyData: res.data.reverse(),
        });
      }

    });

    if (this.props.location.state.documentInfo.childProcess === true) {
      this.props.getDocumentDetailV2Asyn(location.state.processId).then((res: any) => {
        // console.log('getDocumentDetailAsyn', res)
        this.setPdfFile(res.data);

        if (res && res.data && res.data.documentUpdatedData && res.data.documentUpdatedData.editPdfFile) {
          this.props.getIncryptedPDF(res.data.documentUpdatedData.editPdfFile).then((pdf_Data: any) => {

            let pdf_url: any = `${process.env.REACT_APP_SERVER_PDF_ENC_URL}/document/${res.data.documentUpdatedData.editPdfFile
              }.enc.unenc`

            localStorage.setItem('PRIMARYPDFURL', pdf_url);
            this.setState({ url: pdf_url, });
          });
        }

      });

    }
    else {
      this.props.getDocumentDetailAsyn(location.state.processId).then((res: any) => {
        // console.log('getDocumentDetailAsyn', res)
        this.setPdfFile(res.data);

        if (res && res.data && res.data.documentUpdatedData && res.data.documentUpdatedData.editPdfFile) {
          this.props.getIncryptedPDF(res.data.documentUpdatedData.editPdfFile).then((pdf_Data: any) => {

            let pdf_url: any = `${process.env.REACT_APP_SERVER_PDF_ENC_URL}/document/${res.data.documentUpdatedData.editPdfFile
              }.enc.unenc`

            localStorage.setItem('PRIMARYPDFURL', pdf_url);
            this.setState({ url: pdf_url, });
          });
        }

      });
    }
    // this.setPdfFile();
    window.addEventListener(
      "hashchange",
      this.scrollToHighlightFromHash,
      false
    );
  }

  componentWillUnmount() {
    const { location }: any = this.props;
    if (this.state.pdfInfo && this.state.pdfInfo.documentUpdatedData && this.state.pdfInfo.documentUpdatedData.editPdfFile) {
      this.props.EncrptyPdfDataDelAsyn(this.state.pdfInfo.documentUpdatedData.editPdfFile)
    }

  }


  setPdfFile(documentDetailData: any) {
    //let seenStamp =documentDetailData?documentDetailData.documentUpdatedData.seenStamp:false;
    // let pdfUrl = documentDetailData ? documentDetailData.documentUpdatedData.editPdfFile : '';
    // // console.log('Doc verify = ', documentDetailData)
    // localStorage.setItem('PRIMARYPDFURL', pdfUrl);
    this.setState({ seenStamp: documentDetailData.seenStamp, pdfInfo: documentDetailData }, () => {
      this.props.getDocumentHighlights(documentDetailData.document_UUID).then((res: any) => {
        const highlightData = this.props.documentData.filter((dt: any) => dt.coordinates && dt.coordinates.length > 0).map((dt: any) => {
          let p = JSON.parse(dt.coordinates[0]);
          let c = {
            comment: p.comment,
            content: p.content,
            position: p.position,
            id: dt.uuid
          }
          return c;
        });

        //let highlightd = JSON.parse(documentData.coordinates[0]);
        this.setState({
          highlights: highlightData.reverse(),
        });
      });
    });
  }


  callback = (key: any) => {
    // console.log(key);
  }


  resetHighlights = () => {
    this.setState({
      highlights: [],
    });
  };

  toggleDocument = () => {

  };

  scrollViewerTo = (highlight: any) => { };

  scrollToHighlightFromHash = () => {
    const highlight = this.getHighlightById(parseIdFromHash());

    if (highlight) {
      this.scrollViewerTo(highlight);
    }
  };



  getHighlightById(id: string) {
    const { highlights } = this.state;

    return highlights.find((highlight) => highlight.id === id);
  }

  addHighlight(highlight: NewHighlight) {
    const { highlights } = this.state;
    // console.log("Saving highlight", highlight)
    const formData = {
      docId: this.props.documentDetailData.document_UUID,
      commentText: highlight.comment.text,
      highLightText: highlight.content.text,
      isHighLight: true,
      coordinates: JSON.stringify(highlight),

    }
    // this.mainRef.insertText(0, 'Hello', 'bold', true);

    this.props.AddHighlightsAsyn(formData).then((res: any) => {
      this.props.getDocumentHighlights(this.props.documentDetailData.document_UUID).then((res: any) => {
        const highlightData = this.props.documentData.filter((dt: any) => dt.coordinates && dt.coordinates.length > 0).map((dt: any) => {
          let p = JSON.parse(dt.coordinates[0]);
          let c = {
            comment: p.comment,
            content: p.content,
            position: p.position,
            id: dt.uuid
          }
          return c;
        });

        //let highlightd = JSON.parse(documentData.coordinates[0]);
        this.setState({
          highlights: highlightData.reverse(),
        });

        getDocumentComments(this.props.documentDetailData.document_UUID);
      });
    });

  }

  updateHighlight(highlightId: string, position: Object, content: Object) {
    // console.log("Updating highlight", highlightId, position, content);

    this.setState({
      highlights: this.state.highlights.map((h) => {
        const {
          id,
          position: originalPosition,
          content: originalContent,
          ...rest
        } = h;
        return id === highlightId
          ? {
            id,
            position: { ...originalPosition, ...position },
            content: { ...originalContent, ...content },
            ...rest,
          }
          : h;
      }),
    });
  }
  elementChildren(element: any) {
    var childNodes = element.childNodes,
      children: any[] = [],
      i = childNodes.length;

    while (i--) {
      if (childNodes[i].nodeType == 1) {
        children.unshift(childNodes[i]);
      }
    }

    return children;
  }

  printDocumentAsPdf = () => {
    const input: any = document.getElementById('pdfloaderid');
    html2canvas(input)
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        // const pdf = new jsPDF();
        // pdf.addImage(imgData, 'JPEG', 0, 0);
        // pdf.save("download.pdf");

        var doc = new jsPDF("p", "mm", "a4");
        var width = doc.internal.pageSize.getWidth();
        var height = doc.internal.pageSize.getHeight();

        doc.addImage(imgData, 'JPEG', 0, 0, width, height);

        // pdf.output('dataurlnewwindow');
        doc.save("download.pdf");
      })
      ;
  }

  hidePdfDiv = () => {
    this.setState({ isShowpdfColumn: false });
  }

  showPdfDiv = () => {
    this.setState({ isShowpdfColumn: true });
  }

  togglePdfDiv = () => {
    this.setState({ isShowpdfColumn: false });
  }

  closePdfDiv = () => {
    this.setState({ isShowpdfColumn: true });
  }


  private openLink(url: string) {
    let a = document.createElement('a');
    // Firefox requires the link to be in the body
    document.body.appendChild(a);
    a.style.display = 'none';
    a.href = url;
    a.download = 'Certificate.pdf';
    a.click();
    // Remove the link when done
    document.body.removeChild(a);
  }



  initiatpdfNewProcess() {
    // console.log('pdfInfo',this.state.pdfInfo)
    // console.log('docid',this.state.pdfInfo.documentUpdatedData._id)
    const documentId = this.state.pdfInfo.documentUpdatedData._id;
    this.props.pdfNewProcessAsyn(documentId).then((res: any) => {
      this.props.history.push({
        pathname: '/use-this-document',
        // search: '?query=abc',
        state: { documentId: documentId, processId: res.data.processId, createdAt: res.data.createdAt }
      });

    })
  }

  goBack = () => {
    this.props.history.goBack();
  };


  dragoverHandler = (ev) => {
    ev.preventDefault();
    const data = ev.dataTransfer.getData("text/html");
    ev.target.appendChild(document.getElementById(data));
  }

  getValue = (content, delta, source, editor) => {
    //const text = editor.getText(content);
    var a = this.mainRef.current.getEditor().root.innerHTML;
    // console.log(a);
  };

  DelData = () => {
    const { location }: any = this.props;
    this.props.DeleteEditHistoryRecordAsyn(this.state.editDelId).then((res: any) => {
      if (res.message === "Deleted successfully") {
        this.mainRef.current.editor.deleteText(0, this.mainRef.current.editor.getLength());
        this.setState({
          tittleData: '',
          displayAddbtn: true,
          displayUpdatebtn: false,
          displayDelbtn: false,
        });

        this.props.getEditHistoryDataAsyn(location.state.processId).then((res: any) => {
          // console.log('getEditHistoryDataAsyn', res)
          if (res.message === "Fetched") {
            this.setState({
              editHistroyData: res.data.reverse(),
            });
          } else if (res.message === "no data") {
            this.setState({
              editHistroyData: [],
            });
          }

        });

      }
    })

  }

  updateInputValue = (evt) => {
    this.setState({
      tittleData: evt.target.value
    });
  }
  addEditorData = () => {
    const { location }: any = this.props;
    // console.log('location.state.processId', this.props.location.state.processId)
    const input: any = document.getElementById('tittle_name');
    const textdata: any = this.mainRef.current.editor.getText();
    // console.log(this.state.tittleData);
    // console.log(textdata);
    const data = {
      "processId": this.props.location.state.processId,
      "title": this.state.tittleData,
      "message": this.mainRef.current.editor.getText(),
      "messageInHtml": this.mainRef.current.getEditor().root.innerHTML,
    }

    this.props.AddHistoryAsyn(data).then((res: any) => {
      if (res.message === "Saved") {
        this.mainRef.current.editor.deleteText(0, this.mainRef.current.editor.getLength());
        this.setState({
          tittleData: ''
        });

        this.props.getEditHistoryDataAsyn(location.state.processId).then((res: any) => {
          // console.log('getEditHistoryDataAsyn', res)
          if (res.message === "Fetched") {
            this.setState({
              editHistroyData: res.data.reverse(),
            });
          }

        });

      }
    })

  }

  handleEditRecord = (data: any) => {
    // console.log("data  = ", data);
    this.mainRef.current.editor.deleteText(0, this.mainRef.current.editor.getLength());
    this.setState({
      editDelId: data.id,
      tittleData: data.title,
      displayAddbtn: false,
      displayUpdatebtn: true,
      displayDelbtn: true,
    });
    // this.mainRef.current.editor.insertText(0, data.message);
    this.mainRef.current.editor.clipboard.dangerouslyPasteHTML(0, data.messageInHtml);
  }

  editEditorData = () => {
    const { location }: any = this.props;
    const data = {
      "_id": this.state.editDelId,
      "title": this.state.tittleData,
      "message": this.mainRef.current.editor.getText(),
      "messageInHtml": this.mainRef.current.getEditor().root.innerHTML,
    }

    this.props.EditHistoryRecordAsyn(data).then((res: any) => {
      if (res.message === "updated successfully") {
        this.mainRef.current.editor.deleteText(0, this.mainRef.current.editor.getLength());
        this.setState({
          tittleData: '',
          displayAddbtn: true,
          displayUpdatebtn: false,
          displayDelbtn: false,
        });

        this.props.getEditHistoryDataAsyn(location.state.processId).then((res: any) => {
          // console.log('getEditHistoryDataAsyn', res)
          if (res.message === "Fetched") {
            this.setState({
              editHistroyData: res.data.reverse(),
            });
          }

        });
      }
    })

  }



  handleCancle = () => {
    this.mainRef.current.editor.deleteText(0, this.mainRef.current.editor.getLength());
    this.setState({
      tittleData: '',
      displayAddbtn: true,
      displayUpdatebtn: false,
      displayDelbtn: false,
    });
  }

  render() {
    const { url, highlights } = this.state;
    const { location, user }: any = this.props;
    let documentTitle = this.props.documentDetailData ? this.props.documentDetailData.processName : 'New Document Process';

    const dataSource = this.state.editHistroyData ? this.state.editHistroyData.map((row: any) => ({
      id: row._id,
      title: row.title,
      message: row.message,
      messageInHtml: row.messageInHtml,
    })) : [];

    // const isStartNewProcess = location.state ? location.state.viewDocument : null;
    // const isChildProcessTrue = this.props.location.state.documentInfo.childProcess === true ? false : true;
    // const isConcurrentProcessAlreadyInitiated = this.props.location.state.documentInfo.concurrentProcessAlreadyInitiated === true ? true : false;

    // const isUserInProcess = this.props.location.state.documentInfo.userInProcess === true ? true : false;
    // const isUserAlreadySigned = this.props.location.state.documentInfo.userAlreadySigned === true ? true : false;
    // console.log("isUserInProcess ", this.props.location.state)
    // console.log("isUserAlreadySigned ", this.props.location.state.documentInfo.userAlreadySigned)
    // // console.log('documentData');
    // const { documentData }:any = this.props;
    // console.log(documentData);
    return (
      <Container>
        <Spin indicator={antIcon} style={{ alignItems: 'center', justifyContent: 'center', justifyItems: 'center', textAlign: 'center', width: '100%', maxHeight: '100%', position: 'fixed', zIndex: 1111, left: 0, right: 0, top: '45%', bottom: 0 }} spinning={this.state.isLoading} />
        <div className="site-layout-content"
          style={{ marginTop: 0, paddingTop: 0 }}
        //  style={{marginTop:5}}
        >
          {/* <div style={{ padding: '16px 100px 24px 24px'}}> */}
          <div >
            {/* <Row>
               <Col span={15} >
               <Button style={{marginTop:10,float:'right',marginBottom:15}} onClick={() => this.printDocumentAsPdf()}><DownloadOutlined/></Button>
               </Col>
               <Col span={9}></Col>
           </Row> */}
            {/* <h2 style={{paddingTop:10,paddingBottom:10,backgroundColor:"#fff",marginTop:20}}>Requirement Application Form bill Johnson</h2> */}
            <Row style={{ width: '100%', height: '100%', paddingTop: 0, paddingBottom: 5 }} >
              {this.state.isShowpdfColumn &&
                <Col span={15}>
                  <Row style={{ width: '100%', maxWidth: '100%' }}>
                    <Col span={user.userType == 'CHD' ? 23 : 23}>
                      {/* <h2 >{documentTitle}</h2> */}
                      <h3 className="color-ffffff text-capitalize" style={{ fontWeight: 600 }}>
                        <span onClick={() => this.goBack()} style={{ width: 'calc(100% - 50px)', display: 'inline-block', cursor: 'pointer' }}><ArrowLeftOutlined /> Edit Pdf</span>
                        {/* <span>1 of 3</span> */}
                      </h3>
                    </Col>

                    <Col span={8}>

                    </Col>

                    <Col span={1}></Col>
                  </Row>
                </Col>
              }
              {/* <Col span={1}></Col> */}
              <Col span={this.state.isShowpdfColumn ? 9 : 24}>
                <Row>
                  <Col span={18}>
                    <h3 className="color-ffffff text-capitalize" style={{ fontWeight: 600 }}>Copy text which you want to edit from pdf</h3>
                  </Col>
                  <Col span={6} style={{ textAlign: 'right' }}>
                    <Space >
                      <Button type="link" className="document-varification-btn-zoom" onClick={() => this.togglePdfDiv()} ghost> <Image preview={false} width={20} src={'./images/window-expand.png'} /></Button>
                      <Button type="link" className="document-varification-btn-close" onClick={() => this.closePdfDiv()} style={{ color: '#000', fontSize: 20, fontWeight: 'bold', padding: 0, marginTop: -2 }} ghost><CloseOutlined /></Button>
                    </Space>
                  </Col>
                </Row>



              </Col>
            </Row>
            <div className="App boxshadowclass" style={{ display: "flex", height: "111vh", backgroundColor: '#DFE0EB' }}>
              {/* <Sidebar
          highlights={highlights}
          resetHighlights={this.resetHighlights}
          toggleDocument={this.toggleDocument}
        /> */}
              {/* <Row  style={{width:'100%',height:'100%'}} >
         {this.state.isShowpdfColumn &&
         <Col span={15}></Col>
         }
         <Col span={1}></Col>
         <Col span={this.state.isShowpdfColumn?8:23}>
         <Space>
          <Button type="primary" icon={<DownloadOutlined/>} ghost>Download</Button>
          <Button type={'primary'} icon={<PrinterOutlined/>} ghost>Print</Button>
          </Space>
         </Col>
         </Row> */}
              <Row style={{ width: '100%', height: '100%' }} >
                {this.state.isShowpdfColumn &&
                  <Col span={15}>
                    {/* Pdf loader start */}
                    <div
                      id="pdfloaderid"
                      style={{
                        height: "111vh",
                        // width: "75vw",
                        // width: "60vw",
                        width: "100%",
                        position: "relative",
                        marginRight: 40
                      }}
                    >
                      <PdfLoader url={url} beforeLoad={<Spinner />}>
                        {(pdfDocument) => (
                          <PdfHighlighter
                            ref={(ref) => this.pdfhighlightRef = ref}
                            pdfDocument={pdfDocument}
                            enableAreaSelection={(event) => event.altKey}
                            onScrollChange={resetHash}
                            // pdfScaleValue="page-width"
                            scrollRef={(scrollTo) => {
                              this.scrollViewerTo = scrollTo;

                              this.scrollToHighlightFromHash();
                              this.setState({ pdfDOc: pdfDocument });
                            }}
                            onSelectionFinished={(
                              position,
                              content,
                              hideTipAndSelection,
                              transformSelection
                            ) => (<></>
                              // <Tip
                              //   onOpen={transformSelection}
                              //   onConfirm={(comment) => {
                              //     this.addHighlight({ content, position, comment });

                              //     hideTipAndSelection();
                              //   }}
                              // />
                            )}
                            highlightTransform={(
                              highlight,
                              index,
                              setTip,
                              hideTip,
                              viewportToScaled,
                              screenshot,
                              isScrolledTo
                            ) => {
                              const isTextHighlight = !Boolean(
                                highlight.content && highlight.content.image
                              );

                              const component = isTextHighlight ? (<></>
                                // <Highlight
                                //   isScrolledTo={isScrolledTo}
                                //   position={highlight.position}
                                //   comment={highlight.comment}
                                // />
                              ) : (<></>
                                // <AreaHighlight
                                //   isScrolledTo={isScrolledTo}
                                //   highlight={highlight}
                                //   onChange={(boundingRect) => {
                                //     this.updateHighlight(
                                //       highlight.id,
                                //       { boundingRect: viewportToScaled(boundingRect) },
                                //       { image: screenshot(boundingRect) }
                                //     );
                                //   }}
                                // />
                              );

                              return (<></>
                                // <Popup
                                //   popupContent={<HighlightPopup {...highlight} />}
                                //   onMouseOver={(popupContent) =>
                                //     setTip(highlight, (highlight) => popupContent)
                                //   }
                                //   onMouseOut={hideTip}
                                //   key={index}
                                //   children={component}
                                // />
                              );
                            }}
                            highlights={highlights}
                          />
                        )}
                      </PdfLoader>
                      <div style={{ width: 200, height: 200, visibility: 'hidden' }} ><img id="simage" src={this.state.esignImage} style={{ width: '100%', height: '100%', visibility: 'hidden' }} /></div>
                    </div>
                  </Col>
                }

                {/* <Col span={1}>
                  {this.state.isShowpdfColumn
                    ? <Button type="link" style={{ flex: 1, top: '50%', color: '#000' }} icon={<LeftOutlined />} onClick={() => this.hidePdfDiv()}></Button>
                    : <Button type="link" style={{ flex: 1, top: '50%', color: '#000' }} icon={<RightOutlined />} onClick={() => this.showPdfDiv()}></Button>
                  }

                </Col> */}
                <Col span={this.state.isShowpdfColumn ? 9 : 24} className="editor-section">
                  {/* <Sidebar
                    highlights={highlights}
                    resetHighlights={this.resetHighlights}
                    toggleDocument={this.toggleDocument}
                    seenStamp={this.state.seenStamp}
                  /> */}
                  <div style={{ padding: '0 10px' }}>
                    <Input id="tittle_name" className="editor-title" value={this.state.tittleData} onChange={this.updateInputValue} placeholder="Title" />

                    <ReactQuill
                      // onDragOver={(event) => this.dragoverHandler(event)}
                      id="quillmain"
                      modules={modules}
                      placeholder="Write from here..."
                      theme="snow"
                      // value={this.state.highlights}
                      onChange={this.getValue}
                      ref={this.mainRef}
                      className="the-main-editor"
                    />
                  </div>

                  <div className="editor-actions" style={{ padding: '0 10px' }}>
                    {this.state.displayDelbtn && <Button onClick={() => this.DelData()} danger ghost>Delete</Button>}
                    <Button onClick={() => this.handleCancle()} type="primary" ghost style={{ borderColor: "#a1a1C1", marginRight: '10px' }}>Cancel</Button>
                    {this.state.displayAddbtn && <Button onClick={() => this.addEditorData()} type={'primary'}>Save</Button>}
                    {this.state.displayUpdatebtn && <Button onClick={() => this.editEditorData()} type={'primary'}>Edit</Button>}
                  </div>
                  <List
                    className="process-edit-history-tab"
                    itemLayout="horizontal"
                    dataSource={dataSource}
                    renderItem={item => (
                      // <List.Item className="process-edit-history" actions={[<Button style={{ borderColor: "#a1a1C1" }} type={'default'}>Added to pdf</Button>]}>
                      <List.Item className="process-edit-history">
                        <List.Item.Meta
                          title={
                            <>

                              <span className="edit-history-count">{item.title}</span>
                              {/* <Button className="processEditHistory-addToPdf-btn" style={{ border: 'solid 1px #cccccc' }} type={'default'}>Add to pdf</Button> */}
                              <Button className="processEditHistory-edit-btn" onClick={() => this.handleEditRecord(item)} style={{ border: 'none' }} type={'primary'} icon={<EditOutlined />} ghost></Button>
                            </>
                          }
                          description={
                            <>
                              <p className="edit-history-text" dangerouslySetInnerHTML={{ __html: item.messageInHtml }}></p>
                            </>
                          }
                        />
                      </List.Item>
                    )}
                  />
                </Col>
              </Row>
            </div>
          </div>
          <Row
            style={{
              padding: '16px 0px 24px 0px',
              // borderLeft: "1px solid #dfe0eb",
              // borderRight: "1px solid #dfe0eb",
              // borderBottom: "1px solid #dfe0eb",
            }}
          >
            <Col span="16"></Col>
            <Col span="8" style={{ textAlign: "right" }}>

              <Button onClick={() => this.goBack()} type="primary" size="middle" style={{ marginRight: "10px" }} ghost>
                Back
              </Button>

              {/* <Button onClick={() => this.handleSaveEditbtn()} type="primary" size="middle">
                Save Edit
              </Button> */}

            </Col>
          </Row>
          {/* <Row style={{ marginTop: 125, marginBottom: 125 }}><Col span={24}></Col></Row> */}

        </div>
      </Container>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    documentData: state.documenthighlights.documentData,
    documentDetailData: state.documenthighlights.documentDetailData,
    user: state.auth.user,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getDocumentHighlights: (data: any) => dispatch(getDocumentHighlights(data)),
    getDocumentComments: (data: any) => dispatch(getDocumentComments(data)),
    AddHighlightsAsyn: (data: any) => dispatch(AddHighlightsAsyn(data)),
    getIncryptedPDF: (data: any) => dispatch(getIncryptedPDF(data)),
    EncrptyPdfDataDelAsyn: (data: any) => dispatch(EncrptyPdfDataDelAsyn(data)),
    ClearAddHighlightState: () => dispatch(ClearAddHighlightState()),
    getDocumentDetailAsyn: (data: any) => dispatch(getDocumentDetailAsyn(data)),
    getDocumentDetailV2Asyn: (data: any) => dispatch(getDocumentDetailV2Asyn(data)),
    unsetDocumentDetailStateAsync: () => dispatch(unsetDocumentDetailStateAsync()),
    pdfNewProcessAsyn: (data: any) => dispatch(pdfNewProcessAsyn(data)),
    AddHistoryAsyn: (data: any) => dispatch(AddHistoryAsyn(data)),
    getEditHistoryDataAsyn: (data: any) => dispatch(getEditHistoryDataAsyn(data)),
    EditHistoryRecordAsyn: (data: any) => dispatch(EditHistoryRecordAsyn(data)),
    DeleteEditHistoryRecordAsyn: (data: any) => dispatch(DeleteEditHistoryRecordAsyn(data)),
  }
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DocumentEditor))
// export default DocumentVerification;
